import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for   DeleteAddAlgovalues
export const DeleteAddAlgovalues = createSlice({
  name: "DeleteAddAlgovalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    DeleteAddAlgovalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_DeleteAddAlgovalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_DeleteAddAlgovalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    DeleteAddAlgovalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_DeleteAddAlgovalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchAdddeletealgo:(state)=>{
        state.switch = false
    }
  },
});
export default DeleteAddAlgovalues.reducer;
export const {
  DeleteAddAlgovalues_datagrid,
  success_api_call_DeleteAddAlgovalues_datagrid,
  failure_api_call_DeleteAddAlgovalues_datagrid,
  create_DeleteAddAlgovalues_datagrid_complete_api,
  DeleteAddAlgovalues_datagrid_is_success,false_switchAdddeletealgo
} = DeleteAddAlgovalues.actions;
